import Base from './Base';

const Remove = Base('M 5 11 L 5 13 L 19 13 L 19 11 L 5 11 z', '0 0 24 24');

export default Remove;
